<template>
  <div class="result-filter-btn-wrap">
    <!-- <pre>
      {{ this.mobilecheck() }}
    </pre> -->
    <div v-if="mobilecheck()" @click="showMenu" class="mobile-sort-btn">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9" class="mobile-header-expand-icon">
        <path
            fill="currentColor"
            fill-rule="nonzero"
            d="M0 .77145L.750022 0 8 7.4571 15.249978 0 16 .77145 8 9z"
        />
      </svg>
      Raða eftir
    </div>
    <button v-else class="result-filter-btn" @click="showMenu" id="results-filters-btn">
      <span>Raða eftir: {{ sort[cur_sort].title }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16px" height="16px"
           style="margin-left: 5px;">
        <path fill="#6C9F0F" fill-rule="nonzero"
              d="M6.175543 12.8571429c0 .0714285-.029208.1428571-.087623.2142857l-2.795186 2.8482143C3.234318 15.9732143 3.167141 16 3.0912 16c-.070098 0-.137276-.0267857-.201533-.0803571L.085719 13.0625c-.087624-.0952381-.108069-.1994048-.061337-.3125.046733-.1190476.134356-.1785714.26287-.1785714h1.682369V.2857143c0-.0833333.026287-.1517857.078861-.2053572C2.101056.0267857 2.168234 0 2.250016 0h1.682369c.081781 0 .148959.0267857.201533.0803571.052574.0535715.078861.1220239.078861.2053572v12.2857143h1.682369c.081782 0 .14896.0267857.201534.0803571.052574.0535714.078861.1220238.078861.2053572zM15.428571 14v1.7142857c0 .0833333-.026287.1517857-.078861.2053572C15.297136 15.9732143 15.229958 16 15.148177 16H7.857912c-.081782 0-.14896-.0267857-.201534-.0803571-.052574-.0535715-.078861-.1220239-.078861-.2053572V14c0-.0833333.026287-.1517857.078861-.2053571.052574-.0535715.119752-.0803572.201534-.0803572h7.290265c.081781 0 .148959.0267857.201533.0803572.052574.0535714.078861.1220238.078861.2053571zm-1.682368-4.5714286v1.7142857c0 .0833334-.026287.1517858-.078861.2053572-.052574.0535714-.119752.0803571-.201534.0803571H7.857912c-.081782 0-.14896-.0267857-.201534-.0803571-.052574-.0535714-.078861-.1220238-.078861-.2053572V9.4285714c0-.0833333.026287-.1517857.078861-.2053571.052574-.0535714.119752-.0803572.201534-.0803572h5.607896c.081782 0 .14896.0267858.201534.0803572.052574.0535714.078861.1220238.078861.2053571zm-1.682369-4.5714285v1.7142857c0 .0833333-.026287.1517857-.078861.2053571-.052574.0535714-.119752.0803572-.201534.0803572H7.857912c-.081782 0-.14896-.0267858-.201534-.0803572-.052574-.0535714-.078861-.1220238-.078861-.2053571V4.8571429c0-.0833334.026287-.1517858.078861-.2053572.052574-.0535714.119752-.0803571.201534-.0803571h3.925527c.081782 0 .14896.0267857.201534.0803571.052574.0535714.078861.1220238.078861.2053572zM10.381465.2857143V2c0 .0833333-.026287.1517857-.078861.2053571-.052574.0535715-.119752.0803572-.201534.0803572H7.857912c-.081782 0-.14896-.0267857-.201534-.0803572C7.603804 2.1517857 7.577517 2.0833333 7.577517 2V.2857143c0-.0833333.026287-.1517857.078861-.2053572C7.708952.0267857 7.77613 0 7.857912 0h2.243158c.081782 0 .14896.0267857.201534.0803571.052574.0535715.078861.1220239.078861.2053572z"/>
      </svg>
    </button>
    <div v-if="show" style="display: block;" class="result-filter-btn-content">
      <label v-for="(val, index) in sort"
             class="checkbox-filter-label"
             :key="index"
             style="width: 100%;">
        <input type="radio"
               :id="'extra_' + index"
               :value="index"
               v-model.number="cur_sort"/>
        <span class="checkmark"></span>
        <span class="checkbox-filter-hint">{{ val.title }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import func from "../helpers/func";
import { mapMutations } from "vuex";

export default {
  props: ["filters", "selected_filters_count", "car_data", "resultCount"],
  data: function () {
    return {
      sort: [
        {title: "Verð, lægsta fyrst", field: "verd"},
        {title: "Verð, hæsta fyrst", field: "verd", order: 3},
        {title: "Akstur, lægsta fyrst", field: "ekinn"},
        // {title: 'Mileage highest first', field: 'ext_ekinnkm', order: 3},
        {title: "Árgerð, nýir fyrst", field: "argerd", order: 3},
        {title: "Árgerð, eldri fyrst", field: "argerd", order: 4},
        {title: "Skráð á söluskrá", field: "lastupdated", order: 3},
        {title: "Mestur afsláttur", field: "verdtilbod", order: 3}
      ],
      cur_sort: 0,
      show: false
    };
  },
  created: function () {
    if (this.$store.state.sorting) {
      this.cur_sort = this.$store.state.sorting.cur_sort
    } else if (this.filters && this.filters.sort && this.filters.sort.cur_sort) {
      this.cur_sort = this.filters.sort.cur_sort;
    }
    if (["DealersCars", "CarsInStock"].includes(this.$route.name)) {
      this.sort = [
        {title: "Verð, lægsta fyrst", field: "verd"},
        {title: "Verð, hæsta fyrst", field: "verd", order: 3},
        {title: "Mestur afsláttur", field: "discount", order: 3},
        {title: "Drægni, mest fyrst", field: "affinity", order: 3}
      ];
    }

    document.addEventListener('click', this.handleClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClick)
  },
  methods: {
    ...mapMutations([
      "setSorting",
    ]),
    showMenu() {
      this.show = !this.show;
    },
    mobilecheck() {
      return func.mobilecheck();
    },
    handleClick(e) {
      if (
        !this.$el.contains(e.target) &&
        document.querySelector('.result-filter-btn-content') &&
        !document.querySelector('.result-filter-btn-content').contains(e.target)
      ) this.show = false
    }
  },
  watch: {
    cur_sort: function () {
      /* this.$scrollTo(".results-cards-wrap", 1000, { offset: -120 }); */

      if (this.filters && this.filters.sort.cur_sort !== this.cur_sort) {
        this.filters.sort = this.sort[this.cur_sort];
        this.filters.sort.cur_sort = this.cur_sort;
        this.setSorting(this.filters.sort)
      }
      this.show = false;
    }
  }
};
</script>
